<template>
  <div class="app-container">
    <CrudTable entity="StoreUser" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'code', label: 'login.code' },
        'name',
        { field: 'clientName', label: 'storeUser.clientName' },
        { field: 'storeCode', label: 'storeUser.storeCode' },
        { field: 'storeName', label: 'storeUser.storeName' }
      ]
    };
  }
};
</script>

<style scoped></style>
